import baseTheme from './PippoTheme';

const theme = {
  headerMaterialDark: '#636363',
  headerMaterialLight: '#636363',
};

export default { ...baseTheme, ...theme };
